import { computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';

export const useSurfAnalyst = () => {
	const { analyst } = useModuleData();

	// 数据
	const analystData = computed(() => {
		return analyst.data?.data || [];
	});

	// 加载数据（一次性拉取全量数据，不传分页参数）
	const loadAnalystData = async () => {
		await analyst.refresh();
	};

	// 是否为空
	const isEmpty = computed(() => {
		return analyst.empty || !analystData.value.length;
	});

	return {
		analyst,
		analystData,
		loadAnalystData,
		isEmpty
	};
};
